<template>
  <div class="foundation">
    <navbar />

    <!-- Playground -->
    <component v-bind:is="currentLevelComponent"></component>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import {
  ChallengeOperatorOne,
  ChallengeOperatorTwo,
  ChallengeOperatorThree,
  ChallengeOperatorFour,
  ChallengeOperatorFive,
  ChallengeConditionalOne,
  ChallengeConditionalTwo,
  ChallengeConditionalThree,
  ChallengeConditionalFour,
  ChallengeConditionalFive,
  ChallengeConditionalSix,
  ChallengeConditionalSeven,
  ChallengeConditionalEight,
  ChallengeLoopOne,
  ChallengeLoopTwo,
  ChallengeLoopThree,
  ChallengeLoopFour,
  ChallengeLoopFive,
  ChallengeLoopSix,
  ChallengeLoopSeven,
  ChallengeLoopEight,
  ChallengeLoopNine,
  ChallengeFunctionOne,
  ChallengeFunctionTwo,
  ChallengeFunctionThree,
  ChallengeFunctionFour,
  ChallengeFunctionFive,
  ChallengeListOne,
  ChallengeListTwo,
  ChallengeListThree,
  ChallengeListFour,
  ChallengeListFive,
  ChallengeListSix
} from "@/components/levels";
import LevelRepository from "@/repositories/challenges-level-repository";

export default {
  name: "Foundation",

  components: {
    Navbar,
    ChallengeOperatorOne,
    ChallengeOperatorTwo,
    ChallengeOperatorThree,
    ChallengeOperatorFour,
    ChallengeOperatorFive,
    ChallengeConditionalOne,
    ChallengeConditionalTwo,
    ChallengeConditionalThree,
    ChallengeConditionalFour,
    ChallengeConditionalFive,
    ChallengeConditionalSix,
    ChallengeConditionalSeven,
    ChallengeConditionalEight,
    ChallengeLoopOne,
    ChallengeLoopTwo,
    ChallengeLoopThree,
    ChallengeLoopFour,
    ChallengeLoopFive,
    ChallengeLoopSix,
    ChallengeLoopSeven,
    ChallengeLoopEight,
    ChallengeLoopNine,
    ChallengeFunctionOne,
    ChallengeFunctionTwo,
    ChallengeFunctionThree,
    ChallengeFunctionFour,
    ChallengeFunctionFive,
    ChallengeListOne,
    ChallengeListTwo,
    ChallengeListThree,
    ChallengeListFour,
    ChallengeListFive,
    ChallengeListSix
  },

  data() {
    return {
      id: this.$route.params.id,
      levels: []
    };
  },

  created() {
    this.getLevels();
  },

  computed: {
    currentLevelComponent() {
      return this.levels[parseInt(this.id) - 1].name;
    }
  },

  methods: {
    getLevels() {
      this.levels = LevelRepository.getLevels();
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    next();
  }
};
</script>

<style lang="less" scoped></style>
